import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddLawsuitList from "./addLawsuitList";
const MySwal = withReactContent(Swal2);

const AdminPanelLawsuitTextList = (props) => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddLawsuitList, setShowAddLawsuitList] = useState(false);
  const [editLawsuitList, setEditLawsuitList] = useState([]);

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitTextList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa pola</th>
        <th>Tekst</th>
      </tr>
      {banks.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
              {el.topic}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "block",
                    justifyContent: "left",
                  }}
                >
                  {el.name.length > 0
                    ? JSON.parse(el.name).map((el) => <p>{el.value}</p>)
                    : ""}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value={el.id}
                    fieldUID={el.id}
                    field="name"
                    onClick={(e) => {
                      setEditLawsuitList(
                        banks.filter(
                          (eq) => +eq.id === +e.currentTarget.value
                        )[0]
                      );
                      setShowAddLawsuitList(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            {showAddLawsuitList ? (
              <AddLawsuitList
                close={() => {
                  setShowAddLawsuitList(false);
                  getData();
                }}
                list={editLawsuitList}
                mode={"edit"}
              />
            ) : (
              ""
            )}
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Elementy pozwu - listy
            </div>
            {usersTableFirst}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelLawsuitTextList;
